import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "template"]

  connect() {
    this._nextIndex = this._computeNextIndex()
    this._refreshAll()
  }

  addField(event) {
    event?.preventDefault?.()
    if (!this.hasTemplateTarget || !this.hasListTarget) return

    const wrapper = document.createElement("div")
    wrapper.innerHTML = this.templateTarget.innerHTML.trim()
    const row = wrapper.firstElementChild
    if (!row) return

    const idx = this._nextIndex
    this._nextIndex += 1

    row.dataset.tagSchemaBuilderIndex = `${idx}`
    row.querySelectorAll("[name]").forEach((el) => {
      const name = el.getAttribute("name")
      if (!name) return
      el.setAttribute("name", name.replaceAll("__INDEX__", `${idx}`))
    })

    this.listTarget.appendChild(row)
    this._refreshRow(row)
  }

  removeField(event) {
    event?.preventDefault?.()
    const row = event.target.closest("[data-tag-schema-builder-row]")
    row?.remove?.()
  }

  kindChanged(event) {
    const row = event.target.closest("[data-tag-schema-builder-row]")
    if (!row) return
    this._refreshRow(row)
  }

  multipleChanged(event) {
    const row = event.target.closest("[data-tag-schema-builder-row]")
    if (!row) return
    this._refreshRow(row)
  }

  titleChanged(event) {
    const row = event.target.closest("[data-tag-schema-builder-row]")
    if (!row) return
    this._maybeAutoKey(row)
  }

  keyChanged(event) {
    const row = event.target.closest("[data-tag-schema-builder-row]")
    if (!row) return
    row.dataset.keyManual = "true"
    this._refreshKeyPreview(row)
  }

  toggleAdvanced(event) {
    event?.preventDefault?.()
    const row = event.target.closest("[data-tag-schema-builder-row]")
    if (!row) return
    row.dataset.advancedOpen = row.dataset.advancedOpen === "true" ? "false" : "true"
    this._refreshRow(row)
  }

  _refreshAll() {
    if (!this.hasListTarget) return
    this.listTarget.querySelectorAll("[data-tag-schema-builder-row]").forEach((row) => this._refreshRow(row))
  }

  _refreshRow(row) {
    const kind = row.querySelector("[data-tag-schema-builder-kind]")?.value || ""
    const multipleEl = row.querySelector("[data-tag-schema-builder-multiple]")
    const multiple = multipleEl ? multipleEl.checked : false

    const showUnit = kind === "integer" || kind === "number"
    const showRelation = kind === "page"
    const advancedOpen = row.dataset.advancedOpen === "true"

    row.querySelectorAll("[data-tag-schema-builder-unit]").forEach((el) => {
      el.classList.toggle("d-none", !showUnit)
    })
    row.querySelectorAll("[data-tag-schema-builder-relation]").forEach((el) => {
      el.classList.toggle("d-none", !showRelation)
    })

    row.querySelectorAll("[data-tag-schema-builder-advanced]").forEach((el) => {
      el.classList.toggle("d-none", !advancedOpen)
    })

    this._maybeAutoKey(row)
    this._refreshKeyPreview(row)
  }

  _maybeAutoKey(row) {
    const keyEl = row.querySelector("[data-tag-schema-builder-key]")
    if (!keyEl) return
    if (row.dataset.keyManual === "true") return

    const titleEl = row.querySelector("[data-tag-schema-builder-title]")
    const title = titleEl?.value || ""
    const generated = this._slugToSnake(title)
    if (!generated) return
    keyEl.value = generated
  }

  _refreshKeyPreview(row) {
    const keyEl = row.querySelector("[data-tag-schema-builder-key]")
    const preview = row.querySelector("[data-tag-schema-builder-key-preview]")
    if (!keyEl || !preview) return
    preview.textContent = keyEl.value || "—"
  }

  _computeNextIndex() {
    if (!this.hasListTarget) return 0
    let max = -1
    this.listTarget.querySelectorAll("[data-tag-schema-builder-row]").forEach((row) => {
      const raw = row.dataset.tagSchemaBuilderIndex
      const n = raw ? parseInt(raw, 10) : NaN
      if (!Number.isNaN(n)) max = Math.max(max, n)
    })
    return max + 1
  }

  _slugToSnake(text) {
    let s = (text || "").toString().trim().toLowerCase()
    if (!s) return ""
    s = s.replace(/[^a-z0-9]+/g, "_")
    s = s.replace(/^_+|_+$/g, "")
    s = s.replace(/_{2,}/g, "_")
    if (!/^[a-z]/.test(s)) s = `field_${s}`
    if (!s) s = "field"
    return s
  }
}


